import one from "../../images/Svg/team1.svg";
import two from "../../images/Svg/team2.svg";
import three from "../../images/Svg/team3.svg";
import four from "../../images/Svg/team4.svg";
import five from "../../images/Svg/team5.svg";
import six from "../../images/Svg/team6.svg";
import seven from "../../images/Svg/team7.svg";
import eight from "../../images/Svg/team8.svg";

const TeamData = [
  {
    id: 1,
    icon: one,
    name: "Shubham Vyas",
    title: "Co-founder",
    text: "IIT Guwahati, Ex-founder @ anveshan.farm",
    link: "https://www.linkedin.com/in/shubham-vyas/",
  },
  {
    id: 2,
    icon: two,
    name: "Man Mohit",
    title: "Co-founder",
    text: "IIT Guwahati, Ex-product at Ola",
    link: "https://www.linkedin.com/in/man-mohit/",
  },
  {
    id: 3,
    icon: three,
    name: "Mohit Badwal",
    title: "Tech Lead",
    text: "KIIT Bhubaneswar, Ex-founder @ deliverit",
    link: "https://www.linkedin.com/in/mohit-badwal-197b99106/",
  },
  {
    id: 4,
    icon: four,
    name: "Harshmeet",
    title: "Tech Lead",
    text: "IIT Guwahati, Developer at myntra.com",
    link: "https://www.linkedin.com/in/harshmeetsingh/",
  },
  {
    id: 5,
    icon: five,
    name: "Nikhil Nagraj",
    title: " ML Engineer",
    text: "IIT Guwahati, Masters in CS from KU Leuven ML Engineer",
    link: "https://www.linkedin.com/in/nikhilnagaraj",
  },
  {
    id: 6,
    icon: six,
    name: "Md Yasen",
    title: "Full Stack Developer",
    text: "Passionate about tech solving real problems",
    link: "https://www.linkedin.com/in/md-yasen-web/",
  },
  {
    id: 7,
    icon: seven,
    name: "Meghalee Pimpale",
    title: "UI UX Designer",
    text: "UI UX Designer, Architect, Photographer",
    link: "https://www.linkedin.com/in/meghalee-pimpale-326262118",
  },
  {
    id: 8,
    icon: eight,
    name: "Shubhda Vyas",
    title: "Social Media Manager",
    text: "Social Media Manager",
    link: "https://www.linkedin.com/in/shubhdavyas",
  },
];

export default TeamData;
